/* Drømmemøbler: kjører innebygde jQuery-skript (type="text/dm-jq") etter at jQuery og slick er lastet med defer.
   Kjøres i dokumentrekkefølge, før DOMContentLoaded, så $(document).ready og DOMContentLoaded-lyttere virker som før. */
(function () {
  function kjor(rot) {
    var liste = (rot || document).querySelectorAll('script[type="text/dm-jq"]');
    for (var i = 0; i < liste.length; i++) {
      var gammel = liste[i];
      if (gammel.getAttribute('data-dm-kjort')) continue;
      gammel.setAttribute('data-dm-kjort', '1');
      var ny = document.createElement('script');
      ny.text = gammel.text;
      try { gammel.parentNode.insertBefore(ny, gammel.nextSibling); } catch (e) { if (window.console) console.error(e); }
    }
  }
  window.dmKjorJq = kjor;
  kjor(document);
  /* Temaredigereren laster seksjoner på nytt uten å laste siden */
  document.addEventListener('shopify:section:load', function (e) { kjor(e.target); });
})();
